
export enum LimiteNivelSigilo {
  NENHUM = 'NENHUM',
  PUBLICO = 'PUBLICO',
  SEGREDO_JUSTICA = 'SEGREDO_JUSTICA',
  SIGILO_MINIMO = 'SIGILO_MINIMO',
  SIGILO_MEDIO = 'SIGILO_MEDIO',
  SIGILO_INTENSO = 'SIGILO_INTENSO',
  SIGILO_ABSOLUTO = 'SIGILO_ABSOLUTO'
}
